import moment from 'moment';

// เวลาจำลองต่อ tester บน staging (5 ต.ค. 69): เปิดหน้าด้วย ?now=2026-11-11T10:00 (ไม่ใส่ timezone = เวลาไทย)
// → จำใน sessionStorage (ต่อแท็บ) แล้ว callAPI ส่ง header X-Simulated-Now ไปทุก request ของ API/api-pdf
// ฝั่ง server (config simulatedClock เฉพาะ staging) ใช้เวลานี้กับ gate ปฏิทิน + timestamp ที่หน้าเว็บใช้ตัดสินช่วงเวลา
// ล้างด้วย ?now=off (หรือปุ่มในแถบเตือน) · build production: เงื่อนไขด้านล่างเป็น false ตายตัว → โค้ดถูกตัดทิ้ง
export const STORAGE_KEY = 'tcas.simulatedNow';
export const HEADER = 'X-Simulated-Now';

export const simulatedClockEnabled = () => process.env.NODE_ENV === 'development' || process.env.REACT_APP_STAGING === 'true';

const INPUT = /^(\d{4}-\d{2}-\d{2})(?:[T ](\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?))?(Z|[+-]\d{2}:\d{2})?$/;

// คืน ISO UTC หรือ null ถ้ารูปแบบไม่ถูก/วันไม่มีจริง
export const parseSimulatedNow = (value) => {
  const match = INPUT.exec(String(value || '').trim());
  if (!match) return null;
  const [, date, time = '00:00', zone = '+07:00'] = match;
  const parsed = moment.parseZone(`${date}T${time}${zone}`, moment.ISO_8601, true);
  return parsed.isValid() ? parsed.toDate().toISOString() : null;
};

const storage = () => {
  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
};

export const getSimulatedNow = () => {
  if (!simulatedClockEnabled()) return null;
  try {
    return parseSimulatedNow(storage() && storage().getItem(STORAGE_KEY));
  } catch (error) {
    return null;
  }
};

export const clearSimulatedNow = () => {
  try {
    if (storage()) storage().removeItem(STORAGE_KEY);
  } catch (error) {
    // storage ถูกบล็อก — ไม่มีอะไรให้ล้าง
  }
};

const CLEAR_VALUES = ['', 'off', 'clear', 'now'];

// เรียกครั้งเดียวตอนโหลดแอป — อ่าน ?now= แล้วจำ/ล้าง (ค่าผิดรูปแบบ = ไม่เปลี่ยนค่าเดิม)
export const initSimulatedClock = (search = window.location.search) => {
  if (!simulatedClockEnabled()) return null;
  const params = new URLSearchParams(search);
  if (!params.has('now')) return getSimulatedNow();
  const raw = params.get('now');
  if (CLEAR_VALUES.includes(raw.trim().toLowerCase())) {
    clearSimulatedNow();
    return null;
  }
  const iso = parseSimulatedNow(raw);
  if (!iso) {
    console.warn(`[simulated-clock] ?now=${raw} ไม่ถูกรูปแบบ (ตัวอย่าง 2026-11-11T10:00) — ไม่เปลี่ยนเวลาจำลอง`);
    return getSimulatedNow();
  }
  try {
    if (storage()) storage().setItem(STORAGE_KEY, iso);
  } catch (error) {
    return null;
  }
  return iso;
};

// "ตอนนี้" ฝั่งหน้าเว็บ — เวลาจำลองถ้ามี ไม่งั้นเวลาจริง · ใช้กับ gate ที่ FE ตัดสินเอง (วันปิดรับ folio — 2026-10-06)
// ให้ตรงกับ server ที่ได้ header เดียวกัน · production: getSimulatedNow() = null เสมอ → moment() จริง
export const simulatedMoment = () => {
  const iso = getSimulatedNow();
  return iso ? moment(iso) : moment();
};
